import React from "react";
import { useSettings } from "_contexts/useSettings";
import { hexToRgba } from "_assets/js/helpers";
import "./Card.scss";

export default function Card(props) {
  const { settings } = useSettings();
  let className = `paypath-card ${props.className || ""}`;

  // Default color if settings.primary_color is not available
  const defaultColor = "#E8F6F7";
  const primaryColor = settings?.primary_color || defaultColor;

  // Create the gradient with the specified opacities
  let style = {
    background: `linear-gradient(
      180deg,
      ${hexToRgba(primaryColor, 0.01)} 0%,
      ${hexToRgba(primaryColor, 0.06)} 100%
    )`,
  };

  if (props.plain) {
    style = {};
    className += " card-plain";
  }

  return (
    <div id={props.id || ""} className={className} style={style}>
      {props.children}
    </div>
  );
}
